module.exports = __webpack_public_path__ + "img/arrow-right-grey.a1c5221b.svg";